var chunkMapping = {
	"webpack_sharing_consume_default_react-helmet_react-helmet-webpack_sharing_consume_default_rea-34e127": [
		"webpack/container/remote/@do/current-user",
		"webpack/container/remote/@do/graphql-client",
		"webpack/container/remote/@do/walrus",
		"webpack/container/remote/@do/permissions"
	],
	"build_node_components_AvatarDropdown_js-build_node_components_Copilot_CopilotTrigger_js-build-56a0de": [
		"webpack/container/remote/@do/message-bus",
		"webpack/container/remote/@do/flippers"
	],
	"build_node_library_js": [
		"webpack/container/remote/@do/track-exp"
	],
	"build_node_mount_js": [
		"webpack/container/remote/@do/session-manager",
		"webpack/container/remote/@do/ui-copilot",
		"webpack/container/remote/@do/websocket"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/@do/current-user": [
		"default",
		".",
		"webpack/container/reference/@do/current-user"
	],
	"webpack/container/remote/@do/graphql-client": [
		"default",
		".",
		"webpack/container/reference/@do/graphql-client"
	],
	"webpack/container/remote/@do/walrus": [
		"default",
		".",
		"webpack/container/reference/@do/walrus"
	],
	"webpack/container/remote/@do/permissions": [
		"default",
		".",
		"webpack/container/reference/@do/permissions"
	],
	"webpack/container/remote/@do/message-bus": [
		"default",
		".",
		"webpack/container/reference/@do/message-bus"
	],
	"webpack/container/remote/@do/flippers": [
		"default",
		".",
		"webpack/container/reference/@do/flippers"
	],
	"webpack/container/remote/@do/track-exp": [
		"default",
		".",
		"webpack/container/reference/@do/track-exp"
	],
	"webpack/container/remote/@do/session-manager": [
		"default",
		".",
		"webpack/container/reference/@do/session-manager"
	],
	"webpack/container/remote/@do/ui-copilot": [
		"default",
		".",
		"webpack/container/reference/@do/ui-copilot"
	],
	"webpack/container/remote/@do/websocket": [
		"default",
		".",
		"webpack/container/reference/@do/websocket"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}